/**
 * V105-7-2 critic (Medium): the move page's gate chip names its counts ("2 of 3 passed") and stays
 * short enough to wrap at 320px. `checks` comes from the transition route's `plan_gate` (read-only).
 */
export function planGateText(g: { state: string; checks?: { passed: number; total: number; blocked: boolean } | null }): string {
  if (g.state === 'spikes_passed') return 'Checks passed · lock the plan';
  const c = g.checks;
  if (c?.blocked) return 'Waits for a check GAC Pro is writing';
  return c && c.total ? `Waits for feasibility checks · ${c.passed} of ${c.total} passed` : 'Waits for feasibility checks';
}
